import axios from "axios";

export const baseUrl = "https://sandbox.bloom.dev/v2";

export const axiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 60000,
  accept: "application/json",
});

const successResponse = (response) => response;

const errorResponse = (error) => Promise.reject(error);

const setHeaders = (reqConfig) => {
  const token = localStorage.getItem("bloomCredit");
  reqConfig.headers.Authorization = "Bearer " + token;

  return reqConfig;
};

axiosInstance.interceptors.response.use(successResponse, errorResponse);
axiosInstance.interceptors.request.use(setHeaders);
